import { render, staticRenderFns } from "./TrendingNews.vue?vue&type=template&id=b8b9e142&"
import script from "./TrendingNews.vue?vue&type=script&lang=js&"
export * from "./TrendingNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports